var exports = {
  "kL": "x234b8571--892bf3--container",
  "sY": "x234b8571--892bf3--price-diff",
  "Qs": "x234b8571--892bf3--content",
};

module.exports = exports;
